var _ellipse, _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlueLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 50,
    viewBox: "0 0 72 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1389_50110",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 2,
    width: 72,
    height: 46
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.5241,
    cy: 8.53859,
    rx: 8.5241,
    ry: 8.53859,
    transform: "matrix(-1 0 0 1 17.8398 30.3359)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.2928 6.9779C53.8809 4.27782 51.0894 2.58594 48.0465 2.58594C41.8979 2.58594 37.9473 9.12623 40.8003 14.5821L55.6719 43.0216C57.0838 45.7216 59.8752 47.4135 62.9181 47.4135C69.0667 47.4135 73.0174 40.8732 70.1644 35.4174L55.2928 6.9779Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.2953 47.4036C36.1588 47.4102 36.0211 47.4135 35.8822 47.4135C32.8393 47.4135 30.0479 45.7216 28.636 43.0216L17.8007 22.3008C16.8637 20.5089 15.3022 18.9516 13.2801 18.9516C10.6045 18.9516 8.21701 20.1864 6.6543 22.1179L12.8341 10.3C14.637 7.21101 16.4386 2.58594 21.0106 2.58594C21.1457 2.58594 21.2803 2.58927 21.4144 2.59588C21.4208 2.59557 21.4273 2.59527 21.4338 2.59497C21.5612 2.58906 21.6891 2.58594 21.8174 2.58594H21.8221H21.8269C21.9553 2.58594 22.0824 2.58889 22.2097 2.5948C24.1317 2.6827 25.8223 3.41388 27.1335 4.54391C27.9167 5.21238 28.5793 6.03337 29.0732 6.97788L43.9448 35.4174C46.7978 40.8732 42.8472 47.4135 36.6985 47.4135C36.5636 47.4135 36.4292 47.4102 36.2953 47.4036Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1389_50110)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -3.49219,
    y: -5.99219,
    width: 98.1596,
    height: 62.2138,
    fill: "#36AFD9"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueLogo);
export default __webpack_public_path__ + "static/media/blue-logo.c43834e91a5c067cf1cf8caad82e7baf.svg";
export { ForwardRef as ReactComponent };